<template>
  <g class="not-copy">
    <foreignObject :x="x" :y="y" height="48" width="48">
      <img src="@/assets/virtualoffice/interior/keijiban.png" alt="keijiban">
    </foreignObject>
    <rect :x="x" :y="y" height="48" width="48" fill="transparent" @dblclick="openForum()"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'BulletinBoard',
  componentName: 'BulletinBoard',
  props: ['x', 'y', 'transform', 'room_number'],
  computed: {
    ...mapState('virtualOffice', ['forums']),
    forum () {
      return this.forums.find(f => f.room_number == this.room_number)
    }
  },
  methods: {
    openForum () {
      this.$store.commit('virtualOffice/OPEN_FORUM', this.forum.id)
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  width:  100%;
  height: 100%;
  border-radius: 50%;
  object-fit:cover;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fee;
  font-size: 14px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Interior/BulletinBoard.vue